<template>
    <el-card class="box-card" style="padding-top: 51.19px; padding-bottom: 51.19px; overflow-y: auto;">
        <div class="app-body"
             id="view">
            <el-tabs class="support-tools"
                     v-model="active_tab"
                     tab-position="left"
                     type="border-card"
                     @tab-click="handleTabClick">
                <el-tab-pane label="Contacts"
                             name="contacts">
                    <contacts-tab></contacts-tab>
                </el-tab-pane>

                <el-tab-pane label="Communications"
                             name="communications">
                    <communications-tab></communications-tab>
                </el-tab-pane>

                <el-tab-pane label="Sequences"
                             name="sequences">
                    <sequences-tab></sequences-tab>
                </el-tab-pane>

                <el-tab-pane label="Email Suppression"
                             name="email_suppression">
                    <email-suppression></email-suppression>
                </el-tab-pane>

                <template v-if="!isResellerAdmin">
                    <el-tab-pane label="Carriers"
                                 name="carriers">
                        <carriers-tab></carriers-tab>
                    </el-tab-pane>

                    <el-tab-pane label="Integrations"
                                 name="integrations">
                        <integrations-tab></integrations-tab>
                    </el-tab-pane>

                    <el-tab-pane label="Twilio Transfer Numbers"
                                 name="transfer_numbers">
                        <transfer-numbers></transfer-numbers>
                    </el-tab-pane>

                    <el-tab-pane label="LP Number Replacement"
                                 name="lp_number_replacement">
                        <local-presence-number-replacement></local-presence-number-replacement>
                    </el-tab-pane>

                    <el-tab-pane label="LP Tool"
                                 name="local_presence_tool">
                        <local-presence-tool></local-presence-tool>
                    </el-tab-pane>

                    <el-tab-pane label="Restore Tool"
                                 name="restore_tool">
                        <restore-tool></restore-tool>
                    </el-tab-pane>

                    <el-tab-pane label="KYC Review"
                                 name="kyc_review">
                        <kyc-review></kyc-review>
                    </el-tab-pane>

                    <el-tab-pane label="LRN Lookup Tool"
                                 name="lrn_lookup_tool">
                        <lrn-lookup-tool></lrn-lookup-tool>
                    </el-tab-pane>

                    <el-tab-pane label="Porting"
                                 name="porting">
                        <Porting/>
                    </el-tab-pane>

                    <el-tab-pane label="Transcriptions"
                                 name="transcriptions">
                        <transcriptions-tab />
                    </el-tab-pane>

                    <el-tab-pane label="RCPA"
                                 name="recurring_credits">
                        <recurring-credits-tab />
                    </el-tab-pane>

                    <el-tab-pane label="Reset Trial Calls"
                                 name="trial_calls">
                        <trial-calls-tab />
                    </el-tab-pane>

                    <el-tab-pane label="Twilio Voice Insights"
                                 name="twilio_voice_insights">
                        <twilio-voice-insights-tab />
                    </el-tab-pane>
                </template>
            </el-tabs>
        </div>
    </el-card>
</template>

<script>
import auth from '../auth'
import CarriersTab from '../components/support-tools/carriers-tab'
import CommunicationsTab from '../components/support-tools/communications-tab'
import ContactsTab from '../components/support-tools/contacts-tab'
import EmailSuppression from "../components/support-tools/email-suppression"
import IntegrationsTab from '../components/support-tools/integrations-tab'
import KycReview from "../components/support-tools/kyc-review"
import LocalPresenceNumberReplacement from '../components/support-tools/local-presence-number-replacement'
import LocalPresenceTool from '../components/support-tools/local-presence-tool'
import LrnLookupTool from '../components/support-tools/lrn-lookup-tool'
import Porting from '../components/support-tools/porting'
import RecurringCreditsTab from '../components/support-tools/recurring-credits-tab'
import RestoreTool from "../components/support-tools/restore-tool"
import SequencesTab from "../components/support-tools/sequences-tab"
import TranscriptionsTab from '../components/support-tools/transcriptions-tab'
import TransferNumbers from "../components/support-tools/transfer-numbers"
import TrialCallsTab from '../components/support-tools/trial-calls-tab'
import TwilioVoiceInsightsTab from '../components/support-tools/twilio-voice-insights-tab'

export default {
    data() {
        return {
            active_tab: 'contacts',
            auth: auth
        }
    },

    components: {
        TransferNumbers,
        LocalPresenceNumberReplacement,
        LocalPresenceTool,
        RestoreTool,
        SequencesTab,
        ContactsTab,
        CommunicationsTab,
        CarriersTab,
        IntegrationsTab,
        EmailSuppression,
        KycReview,
        LrnLookupTool,
        Porting,
        TranscriptionsTab,
        RecurringCreditsTab,
        TrialCallsTab,
        TwilioVoiceInsightsTab,
    },

    computed: {
        isResellerAdmin() {
            return auth.user && auth.user.profile && auth.user.profile.is_reseller
        }
    },

    mounted() {
        const {query} = this.$route
        if (query && query.tab) {
            this.active_tab = query.tab
        }

        if (this.isResellerAdmin) {
            this.active_tab = 'sequences'
        }
    },

    methods: {
        handleTabClick(tab, event) {
            this.$router.push({query: {tab: tab.name}})
        }
    },

    watch: {
        $route({params, query}) {
            if (query.tab) {
                this.active_tab = query.tab
            }
        },
    },

    beforeRouteEnter(to, from, next) {
        auth.check()
            .then((res) => {
                next()
            })
            .catch((err) => {
                next({name: 'Login', query: {redirect: to.fullPath}})
            })
    }
}
</script>
